export default function formatCurrency(value) {

  return (
    <span>
      {new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(value)}
    </span>
  );
}